import { render, staticRenderFns } from "./Tamamlama.vue?vue&type=template&id=46bbce74"
import script from "./Tamamlama.vue?vue&type=script&lang=js"
export * from "./Tamamlama.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports